<template>
  <highcharts :options="chartOptions"></highcharts>
</template>

<script>
import { Chart } from 'highcharts-vue';

export default {
  components: {
    highcharts: Chart,
  },
  computed: {
    projects: {
      get: function() {
        return this.$store.state.projects;
      },
      set: function(Project) {
        this.$store.dispatch('setProjects', Project);
      },
    },
    schema: {
      get: function() {
        return this.$store.state.schema;
      },
      set: function(newSchema) {
        this.$store.dispatch('setSchema', newSchema);
      },
    },

    thermalGlassSeries() {
      let thermalGlassData = [];
      const glassUData = new Set();
      const glassMaterialSet = new Set();
      //add glass from window 6B
      this.schema.inputs.step3B.windowTypeArrObj.forEach(window => {
        window.orientationObj.forEach(orient => {
          if (orient.calcOpenableArea !== 0 && orient.calcOpenableArea !== '') {
            glassUData.add(orient.uValueNonOpaque);
            glassMaterialSet.add(orient.selectedNonOpaqueMaterial.material);
          }
        });
      });

      //Add glass from ventilator 6B
      this.schema.inputs.step3C.ventilatorArrObj.forEach(venti => {
        if (venti.calcGlassArea !== 0 && venti.calcGlassArea !== '') {
          glassUData.add(venti.uValueMaterial);
          glassMaterialSet.add(venti.selectedGlassMaterial.material);
        }
      });
      this.glassMaterialData = Array.from(glassMaterialSet);
      let glassUDataArr = Array.from(glassUData);
      console.log('Glass Material Data', this.glassMaterialData);
      let outerArr = [];
      this.glassMaterialData.forEach((glass, index) => {
        let subArr = [];
        subArr.push(glass);
        subArr.push(glassUDataArr[index]);
        outerArr.push(subArr);
      });
      // thermalGlassData.push({
      //         name: this.schema.inputs.step1.project_name,
      //         data: Array.from(glassUData),
      //       });
      // console.log('Thermal Glass Data', thermalGlassData);
      return outerArr;
    },
    chartOptions() {
      return {
        chart: {
          type: 'column',
          width: 300,
          height: 300,
        },
        credits: {
          enabled: false,
        },
        title: {
          text: 'Thermal Transmittane of Glass assembly',
        },
        xAxis: {
          // type: 'category',
          // categories: this.projectNames,
          categories: [Array.from(this.glassMaterialData)],
          title: {
            text: 'Projects',
          },
        },
        tooltip: {
          // headerFormat: '{series.name[0]}',
          // formatter() {
          //   this.points.forEach(function(point) {
          //     let s = `${point.series.name}`;
          //   });
          //   return s;
          // },
        },
        yAxis: {
          title: {
            text: 'U-value (W/m2.k)',
          },
        },
        legend: {
          enabled: true,
        },
        plotOptions: {
          column: {
            minPointLength: 3,
          },
        },

        // series: this.thermalGlassSeries,
        series: [{ name: this.schema.inputs.step1.project_name, data: this.thermalGlassSeries }],
      };

      // };
    },
  },
  data() {
    return {
      glassMaterialData: [],
    };
  },
};
</script>

<style></style>
